import React from "react";
import { Link } from "react-router-dom";
import { paths } from "@/navigation/paths";
import { useTranslation } from "react-i18next";
import { LanguageSwitcher } from "@/components/ui/LanguageSwitcher";

export const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center relative">
      <div className="absolute top-6 right-6">
        <LanguageSwitcher />
      </div>
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-8 text-center">
        <div className="text-6xl font-bold text-gray-300 mb-4">404</div>
        <h1 className="text-3xl font-bold text-gray-800 mb-4">{t("notFound.title")}</h1>
        <p className="text-gray-600 text-lg mb-6">{t("notFound.description")}</p>
        <Link
          to={paths.ROOT}
          className="inline-block bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded transition-colors duration-200"
        >
          {t("notFound.home")}
        </Link>
      </div>
    </div>
  );
};
